import script from "./LoginView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__